export enum TimesTypes {
    SLA = "SLA",
    OLA = "OLA"
}